'use client';

import { cn } from '@core/utils';

import { AdBadge } from '@/app/_components/ads';
import { AD_UNIT_IDS } from '@/constants/ad';
import { AD_MOCK_DATA, AD_MOCK_MODE, isAdHidden, useAd } from '@/hooks/useAd';

export const PolicyDetailAd = () => {
  const { containerRef, adState } = useAd(AD_UNIT_IDS.POLICY_DETAIL);

  if (isAdHidden(adState)) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={cn(
        'group relative mx-20 mb-28 cursor-pointer overflow-hidden rounded-small transition-opacity duration-150 hover:opacity-90',
        adState === 'loading' && 'aspect-[335/81] animate-pulse bg-Gray-100',
        adState === 'idle' && 'hidden',
      )}
    >
      <AdBadge />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        data-adrop-native="asset"
        src={AD_MOCK_MODE ? AD_MOCK_DATA.asset : undefined}
        className="aspect-[335/81] w-full border-0 object-cover"
        alt=""
      />
      <p data-adrop-native="headline" className="hidden" />
      <p data-adrop-native="body" className="hidden" />
    </div>
  );
};
